import { render, staticRenderFns } from "./NewMultiWhatsappChannel.vue?vue&type=template&id=3cc811df&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./NewMultiWhatsappChannel.vue?vue&type=script&lang=js"
export * from "./NewMultiWhatsappChannel.vue?vue&type=script&lang=js"
import style0 from "./NewMultiWhatsappChannel.vue?vue&type=style&index=0&id=3cc811df&prod&lang=scss&scoped=true"
import style1 from "./NewMultiWhatsappChannel.vue?vue&type=style&index=1&id=3cc811df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc811df",
  null
  
)

export default component.exports